/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * Helper to transform the JSON API results to proper frontend objects (app discover section elements)
 *
 * @param element The JSON API element to transform
 */
export function parseApiResponse(element) {
    const appElement = { ...element };
    if (appElement.date) {
        appElement.date = Date.parse(appElement.date);
    }
    if (appElement.expiryDate) {
        appElement.expiryDate = Date.parse(appElement.expiryDate);
    }
    if (appElement.type === 'post') {
        return appElement;
    }
    else if (appElement.type === 'showcase') {
        return appElement;
    }
    else if (appElement.type === 'carousel') {
        return appElement;
    }
    throw new Error(`Invalid argument, app discover element with type ${element.type ?? 'unknown'} is unknown`);
}
/**
 * Filter outdated or upcoming elements
 *
 * @param element Element to check
 */
export function filterElements(element) {
    const now = Date.now();
    // Element not yet published
    if (element.date && element.date > now) {
        return false;
    }
    // Element expired
    if (element.expiryDate && element.expiryDate < now) {
        return false;
    }
    return true;
}
